<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="scheduled">
					<app-heading title="Scheduled Events">
						<template slot="right">
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="events"
								:headers="headers"
								:total="count"
								@update="fetchEvents"
							>
								<template v-slot:data="{ item }">
									<app-json :data="item.data" />
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { eventsTabs } from '@/datasources/tabs'

export default {
	data() {
		return {
			events: [],
			tabs: eventsTabs,
			count: -1,
			headers: [{
				text: 'ID',
				value: 'id',
				sortable: false,
			}, {
				text: 'Name',
				value: 'name',
				sortable: false,
			}, {
				text: 'Remaining',
				value: 'scheduled',
				sortable: false,
			}, {
				text: 'Data',
				value: 'data',
				sortable: false,
			}],
			updateInterval: null,
		}
	},
	created() {
		this.updateRemaining()
	},
	methods: {
		async fetchEvents(pagination) {
			const request = this.$ravello.request()
				.to('system')
				.to('events')
				.to('scheduled')
				.fromPagination(pagination)

			try {
				this.events = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		updateRemaining() {
			this.updateInterval = setInterval(() => {
				this.events = this.events.map((event) => {
					if (event.scheduled) {
						event.scheduled -= 1
					}
					return event
				})
			}, 1000)
		},
	},
	beforeDestroy() {
		clearInterval(this.updateInterval)
	},
}
</script>
